import type { Holerite } from '../../models/holerite.model';
import type { FormatoRemessaHolerite } from '../../services/holerites.service';

export interface ArquivoRemessaHolerite {
  documentos: Holerite[];
  registrosMaximos: number;
}
export interface PlanoRemessaHolerite {
  arquivos: ArquivoRemessaHolerite[];
  erro: string;
}

/** Limites de processamento do sistema, não limites comerciais do banco. */
export const MAX_HOLERITES_REMESSA = 500;
export const MAX_REGISTROS_REMESSA = 50_000;

function funcionario(h: Holerite): string {
  const cpf = (h.dados['funcionarioCpf'] || '').replace(/\D/g, '');
  if (cpf) return `cpf:${cpf}`;
  return ['funcionarioMatricula', 'funcionarioBanco', 'funcionarioAgencia', 'funcionarioConta']
    .map(k => (h.dados[k] || '').trim().replace(/^0+(?=\d)/, '')).join('|');
}

export function planejarArquivosRemessa(
  documentos: Holerite[], formato: FormatoRemessaHolerite, operacao: string, tamanho: number
): PlanoRemessaHolerite {
  if (formato === 'cnab400' && operacao === 'X') return { arquivos: [{ documentos: [], registrosMaximos: 2 }], erro: '' };
  if (!Number.isInteger(tamanho) || tamanho < 1 || tamanho > MAX_HOLERITES_REMESSA) {
    return { arquivos: [], erro: 'Informe de 1 a 500 holerites por arquivo.' };
  }
  const grupos = new Map<string, Holerite[]>();
  for (const h of [...documentos].sort((a, b) => (a.id || '').localeCompare(b.id || ''))) {
    const chave = funcionario(h);
    const grupo = grupos.get(chave) || [];
    grupo.push(h); grupos.set(chave, grupo);
  }
  const peso = (h: Holerite): number => formato === 'cnab200' ? 100
    : ['E', 'D'].includes(operacao) ? 1 : h.lancamentos.length + 2;
  const arquivos: ArquivoRemessaHolerite[] = [];
  let atual: ArquivoRemessaHolerite = { documentos: [], registrosMaximos: 2 };
  for (const grupo of grupos.values()) {
    const registros = grupo.reduce((total, h) => total + peso(h), 0);
    if (grupo.length > tamanho || registros + 2 > MAX_REGISTROS_REMESSA) {
      return { arquivos: [], erro: 'Os holerites de um funcionário excedem o tamanho do arquivo. Aumente o limite ou revise a seleção; o funcionário não será dividido entre arquivos.' };
    }
    if (atual.documentos.length && (atual.documentos.length + grupo.length > tamanho || atual.registrosMaximos + registros > MAX_REGISTROS_REMESSA)) {
      arquivos.push(atual); atual = { documentos: [], registrosMaximos: 2 };
    }
    atual.documentos.push(...grupo); atual.registrosMaximos += registros;
  }
  if (atual.documentos.length) arquivos.push(atual);
  if (formato === 'cnab400' && operacao === 'S' && arquivos.length > 1) {
    return { arquivos: [], erro: 'Substituição de lote (S) exige revisar o lote inteiro em um arquivo. A divisão foi bloqueada para evitar substituições parciais; confirme o procedimento com o Santander.' };
  }
  return { arquivos, erro: '' };
}
